var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#008000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "6,28 6,5 26,5 26,19 6,19 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    width: 4,
    height: 4,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 3,
    height: 4,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 9,
    width: 3,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 3,
    height: 4,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 3,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 4,
    height: 4,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 4,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 4,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 3,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 3,
    height: 3,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 3,
    height: 4,
    style: {
      fill: "#008000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 3,
    height: 4,
    style: {
      fill: "#008000"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishFlag);
export default __webpack_public_path__ + "static/media/finish_flag.2bf182d282beaed5a2309ae730771f4c.svg";
export { ForwardRef as ReactComponent };